import { ERoute, TRoute } from "types/Global"
import AuthenticityCheck from "./AuthenticityCheck"
import TecDoc from "./ComplexVAS/TecDoc/TecDoc"
import TecRMI from "./ComplexVAS/TecRMI/TecRMI"
import CounterfeitReport from "./ComplexVAS/CounterfeitReport/CounterfeitReport"
import SecondScan from "./ComplexVAS/SecondScan/SecondScan"
import StartScreen from "./StartScreen"
import MAPPCodeScreen from "./StartScreen/subpages/MAPPCodeScreen"

export const routes: TRoute[] = [
  {
    path: ERoute.ROOT,
    Component: StartScreen,
  },
  {
    path: ERoute.MAPPCodeScreen,
    Component: MAPPCodeScreen,
  },
  {
    path: ERoute.AUTHENTICITY_CHECK,
    Component: AuthenticityCheck,
  },
  {
    path: ERoute.COUNTERFEIT,
    Component: CounterfeitReport,
  },
  {
    path: ERoute.SECONDSCAN,
    Component: SecondScan,
  },
  {
    path: ERoute.TECDOC,
    Component: TecDoc,
  },
  {
    path: ERoute.TECRMI,
    Component: TecRMI,
  },
]
